import { EMAIL_CONFIRMATION_PARAM, PASSWORD_RESET_PARAM } from '../shared.js';

/**
 * Quando quem não está logado vê o site do RPG Desk (docs/spec/landing.md): sem conta salva, sem
 * convite, sem o link de um e-mail (a confirmação, a troca do e-mail ou a recuperação da senha;
 * docs/spec/email.md), fora do app de Windows e do app instalado. Os outros vão direto ao formulário de
 * entrar.
 */
export type EntryContext = {
  /** a conta salva neste navegador (com ela, o `/api/me` está respondendo) */
  token: string | null;
  /**
   * o `location.search` da página: `?room=` é um convite; `?confirm-email=` e `?reset-password=`, os
   * links dos e-mails
   */
  search: string;
  /** o app de Windows */
  desktop: boolean;
  /** o app instalado (a tela inicial do celular ou do computador) */
  standalone: boolean;
};

export function showSiteFirst({ token, search, desktop, standalone }: EntryContext): boolean {
  if (token || desktop || standalone) return false;
  const params = new URLSearchParams(search);
  return !params.has('room') && !params.has(EMAIL_CONFIRMATION_PARAM) && !params.has(PASSWORD_RESET_PARAM);
}

/** O contexto da página de verdade. */
export function browserEntry(token: string | null): EntryContext {
  return {
    token,
    search: window.location.search,
    desktop: !!(window as { rpgDeskDesktop?: unknown }).rpgDeskDesktop,
    standalone: typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches,
  };
}
